import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface ModernHeaderProps {
  title: string;
  subtitle?: string;
  backButton?: boolean;
  backPath?: string;
  actions?: ReactNode;
  sx?: any;
}

export const ModernHeader = ({
  title,
  subtitle,
  backButton = false,
  backPath,
  actions,
  sx = {},
}: ModernHeaderProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      display="flex"
      gap={2}
      alignItems="center"
      justifyContent="space-between"
      sx={{
        backgroundColor: "#FFFFFF",
        px: 3,
        py: 2.5,
        borderRadius: "16px",
        border: "1px solid rgba(226, 232, 240, 0.8)",
        mb: 3,
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: "linear-gradient(90deg, #D58E4E, rgba(213, 142, 78, 0.2))",
        },
        ...sx,
      }}
    >
      <Box display="flex" gap={2} alignItems="center">
        {backButton && (
          <IconButton
            onClick={handleBack}
            sx={{
              backgroundColor: "#FEF7F0",
              border: "1px solid #FDF0E1",
              "&:hover": {
                backgroundColor: "#FDF0E1",
              },
            }}
          >
            <ArrowBackIcon sx={{ color: "#D58E4E", fontSize: 20 }} />
          </IconButton>
        )}
        <Box>
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, color: "#1E293B" }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ color: "#64748B", mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {actions && <Box>{actions}</Box>}
    </Box>
  );
};
